import styled from '@emotion/styled'
import { StyledHTMLElement } from 'shop/theme/types'

export const SpinnerContainer = styled.div<StyledHTMLElement>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '100px 0'
}))
